export default{
    bicis: [],
    biciSelec: null
}